import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

const {
  VITE_NODE_ENV: environment,
  VITE_SENTRY_DSN: dsn,
  VITE_BUILD_SHA: release,
} = import.meta.env;

if (environment === 'prod' || environment === 'stage') {
  const integrations = [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    // capture react errors
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      minReplayDuration: 15000,
      networkDetailAllowUrls: [
        window.location.origin,
        /.*\.corso\.com/,
        /digitaloceanspaces.com/,
      ],
      networkCaptureBodies: true,
    }),

    Sentry.extraErrorDataIntegration({
      depth: Infinity,
    }),
    Sentry.thirdPartyErrorFilterIntegration({
      //! this must match sentry plugin in vite config
      filterKeys: ['crew-customer-ui'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ];

  Sentry.init({
    environment,
    dsn,
    normalizeDepth: Infinity,
    attachStacktrace: true,
    integrations,
    // This option is required for capturing headers and cookies.
    sendDefaultPii: true,
    tracePropagationTargets: [/^https:\/\/api\.corso\.com/],
    ignoreErrors: [
      'Object Not Found Matching Id', // https://github.com/getsentry/sentry-javascript/issues/3440
      'Invalid call to runtime.sendMessage()', // extension error (https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/API/runtime/sendMessage)
    ],
    release,
    // sentry recommends adjusting this value in production for sampling transactions for performance monitoring
    tracesSampleRate: 0.01,
    // replay integration configuration
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.01,
  });

  Sentry.setTag(`isEmbedded`, window.parent !== window);
}
